export default __webpack_public_path__ + "static/media/txt_title.aeaf38ec.svg";